import Backbone from "backbone";


export default Backbone.Model.extend("ColumnModel", {
    defaults: {
        key: "",
        original: "",
        safe: false,
        title: "",
        type: "text",
        info: {}
    },

    idAttribute: "key",

    initialize() {
        this._models = {
            length: 0,
            byId: {}
        };
    }
});
